/**
 * CardButtonContainer component.
 */
import Fonts from '@shared/assets/style/default/fonts';
import Screen from '@shared/utils/screen';
import styled from 'styled-components';
import withOpacity from '@shared/components/utils/hoc/withOpacity';

/**
 * Styled card horizontal button container.
 */
const CardButtonContainer = styled.div<{
  active?: boolean;
  color?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  background: ${(props) => {
    return props?.active ? '#FFFFFFCC' : '#090909CC';
  }};
  border: ${(props) => {
      return props?.active ? '#09090933' : props?.color || '#FFFFFF';
    }}
    solid ${2 * Screen.widthRatio}px;
  border-radius: ${20 * Screen.widthRatio}px;
  color: ${(props) => (props.active ? '#000000' : '#FFFFFF')};
  font-family: ${Fonts['regular']};
  font-size: ${20 * Screen.widthRatio}px;
  right: ${8 * Screen.widthRatio}px;
  height: ${30 * Screen.widthRatio}px;
  width: ${30 * Screen.widthRatio}px;
`;

export default withOpacity(CardButtonContainer);
